import React from "react";

const APP_URL = process.env.REACT_APP_FILE_URL;
const apiDocs = `${APP_URL}/api-documentation`;

const ApiDocsLayer = () => {
  return (
    <div className="card p-0">
      <div className="card-body">
      <div style={{ height: "80vh", border: "none"}}>
        <iframe
          title="Swagger UI"
          src={apiDocs}
          width="100%"
          height="100%"
          style={{ border: "none", borderRadius: "12px" }}
        />
        </div>
      </div>
    </div>
  );
};

export default ApiDocsLayer;
